const initTabs = () => {
  const tabs = document.querySelectorAll('[data-tabs]');
  if (!tabs.length) return;
  tabs.forEach((tab) => {
    const buttons = tab.querySelectorAll('[data-tab-button]'),
      cards = tab.querySelectorAll('[data-tab-card]'),
      hover = tab?.querySelector('[data-tab-hover]'),
      pagination = tab.querySelectorAll('[data-tab-pagination]');

    buttons.forEach((button, index) => {
      button.addEventListener(hover ? 'mouseover' : 'click', (e) => {
        e.preventDefault();
        const activeButton = tab.querySelector('[data-tab-button].is-active'),
          activeCard = tab.querySelector('[data-tab-card].is-active'),
          activePagination = tab.querySelector(
            '[data-tab-pagination].is-active'
          );
        activeButton?.classList.remove('is-active');
        activeCard?.classList.remove('is-active');
        activePagination?.classList.remove('is-active');
        button.classList.add('is-active');
        button.scrollIntoView({ inline: "start", block: "nearest", behavior: "smooth" });
        cards[index].classList.add('is-active');
        pagination[index]?.classList.add('is-active');
      });
    });
  });
};

export default initTabs;
